import React, {
	ReactNode, createContext, useMemo, useState,
} from 'react';

import Confirmation, { IConfirmationProps } from './Confirmation';

export const ConfirmationContext = createContext(null);

interface IConfirmationProviderProps {
	children?: ReactNode;
}

export default function ConfirmationProvider({
	children,
}: IConfirmationProviderProps) {
	const [confirmationProps, setConfirmationProps] = useState(null);

	const showConfirmation = (props: IConfirmationProps) => {
		setConfirmationProps({
			...props,
			open: true,
		});
	};

	const hideConfirmation = () => {
		setConfirmationProps((prevProps: any) => (prevProps ? { ...prevProps, open: false } : null));
	};

	const contextValue = useMemo(
		() => ({
			showConfirmation,
			hideConfirmation,
		}),
		[],
	);

	return (
		<ConfirmationContext.Provider value={contextValue}>
			{children}
			<Confirmation {...confirmationProps} />
		</ConfirmationContext.Provider>
	);
}
